module.exports = __webpack_public_path__ + "img/DW365-341.caf15606.jpg";